import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setTimeFormat: YJSChangeHandler<
  DatabaseChangeType.SET_DATE_FIELD_TIME_FORMAT
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.timeFormat = change.timeFormat;
  });
};
